import React from 'react';

const NoImage = ({itemId, klassName}) => {
    const id = parseInt(itemId, 16) % 6 + 1;
    return <div className={klassName}
                style={{'backgroundImage': `url(https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-${id}_large.png)`}}/>
}

export default NoImage;
